import React, { useEffect, useRef, useState } from "react";
import ProgressBar from "../ProgressBar";
import { ProgressItem } from "../ProgressItem";
import {
  IconStep1,
  IconStep10,
  IconStep11,
  IconStep12,
  IconStep13,
  IconStep14,
  IconStep15,
  IconStep16,
  IconStep2,
  IconStep3,
  IconStep4,
  IconStep5,
  IconStep6,
  IconStep7,
  IconStep8,
  IconStep9,
} from "@icons/index";

const STEPS: any = {
  "/insight": [
    { key: 1, label: "Extracting Video", icon: <IconStep9 />, status: "success" },
    { key: 2, label: "Classifying Content", icon: <IconStep10 />, status: "success" },
    { key: 3, label: "Analyzing Visuals", icon: <IconStep11 />, status: "success" },
    { key: 4, label: "Analyzing Audio", icon: <IconStep12 />, status: "success" },
    { key: 5, label: "Identifying Language", icon: <IconStep13 />, status: "loading" },
    { key: 6, label: "Analyzing Structure", icon: <IconStep14 />, status: "loading" },
    { key: 7, label: "Matching with Database", icon: <IconStep15 />, status: "failed" },
    { key: 8, label: "Generating Results", icon: <IconStep16 />, status: "failed" },
  ],
  "/script-rewrite": [
    { key: 1, label: "Analyzing Product Features", icon: <IconStep1 />, status: "success" },
    { key: 2, label: "Generating Attributes & Selling Points", icon: <IconStep2 />, status: "success" },
    { key: 3, label: "Analyzing Target Audience", icon: <IconStep3 />, status: "success" },
    { key: 4, label: "Determining Video Language", icon: <IconStep4 />, status: "success" },
    { key: 5, label: "Aligning with Local Culture & Nuances", icon: <IconStep5 />, status: "loading" },
    { key: 6, label: "Checking Script Compliance", icon: <IconStep6 />, status: "loading" },
    { key: 7, label: "Planning Script Structure", icon: <IconStep7 />, status: "failed" },
    { key: 8, label: "Generating Results", icon: <IconStep8 />, status: "failed" },
  ],
};

interface TransitionPanelProps {
  onRetry: () => void;
  status: Status;
}

export const TransitionPanel: React.FC<TransitionPanelProps> = React.memo(({ onRetry, status }) => {
  const [current, setCurrent] = useState(0); // 0-8
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const progressRef = useRef(0);
  const prevStatusRef = useRef<Status>(status);
  const pathname = window.location.pathname;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (status === "loading" && prevStatusRef.current !== "loading") {
      setCurrent(0);
      setProgress(0);
      progressRef.current = 0;
    }
    prevStatusRef.current = status;
  }, [status]);

  // 核心状态逻辑
  useEffect(() => {
    const updateProgress = (target: number) => {
      const anim = setInterval(() => {
        setProgress((prev) => {
          const next = Math.min(prev + 2, target);
          progressRef.current = next;
          return next;
        });
        if (progressRef.current >= target) clearInterval(anim);
      }, 20);
    };

    if (status === "succeeded" || status === "failed") {
      setCurrent(8);
      updateProgress(100);
      return;
    }

    if (current < 7) {
      timerRef.current = setTimeout(() => {
        setCurrent((c) => c + 1);
        updateProgress(Math.round(((current + 1) / 8) * 100));
      }, 5000);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [current, status]);

  // 步骤状态计算
  const getStepStatus = (stepIdx: number) => {
    if (status === "succeeded") return "succeeded";
    if (status === "failed") return stepIdx === 7 ? "failed" : "succeeded";
    return stepIdx < current ? "succeeded" : "loading";
  };

  return (
    <div className="flex-1 flex flex-col justify-between min-w-[320px] h-full overflow-hidden">
      <div className="flex flex-col gap-4 mb-6 p-[16px] overflow-y-scroll scrollbar-hide">
        {STEPS[pathname].map((step: any, idx: any) => {
          return (
            <ProgressItem
              key={step.key}
              icon={step.icon}
              label={step.label}
              status={getStepStatus(idx)}
              onRetry={onRetry}
            />
          );
        })}
      </div>
      {/* </div> */}
      <ProgressBar percent={progress} />
    </div>
  );
});
